import CreateHomeContainer from "../containers/CreateHomeContainer";

const CreateHomePage = () => {
  return (
    <CreateHomeContainer />
  );
};

export default CreateHomePage;
